<template>
  <section id="services" class="fade-in section">
    <h2>{{ $t('services.title') }}</h2>
    <div class="services-grid">
      <div class="service-card" v-for="(item, i) in services" :key="i">
        <div class="service-icon"><i :class="item.icon"></i></div>
        <h3>{{ $t(item.title) }}</h3>
        <p>{{ $t(item.text) }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServicesSection',
  data() {
    return {
      services: [
        { icon: 'fas fa-palette', title: 'services.cards.design.title', text: 'services.cards.design.text' },
        { icon: 'fas fa-hospital', title: 'services.cards.hospital.title', text: 'services.cards.hospital.text' },
        { icon: 'fas fa-cut', title: 'services.cards.custom.title', text: 'services.cards.custom.text' }
      ]
    };
  }
};
</script>

<style scoped>
</style>
